import { gql } from '@apollo/client';

export const CUSTOM_PACKAGES_QUERY = gql`
  query CustomPackagesQuery {
    customPackages {
      id
      name
      fileId
      variablesIncluded {
        id
        key
      }
      purchasedAt
    }
  }
`;

export const PACKAGE_QUERY = gql`
  query PackageQuery($packageId: ID!) {
    package(packageId: $packageId) {
      id
      name
      fileId
      variablesIncluded {
        id
        key
      }
      purchasedAt
    }
  }
`;

export const DEFAULT_ENHANCEMENT_PACKAGES_QUERY = gql`
  query DefaultEnhancementPackagesQuery {
    defaultEnhancementPackages
  }
`;
